import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ContentPreview} from "../interface/content-preview";
import {LazyLoadImageModule} from "ng-lazyload-image";
import {RouterLink} from "@angular/router";
import {PipeModule} from "../../pipe/pipe.module";

@Component({
	selector: 'fb-blog-more-stories',
	standalone: true,
	imports: [CommonModule, LazyLoadImageModule, RouterLink, PipeModule],
	templateUrl: './blog-more-stories.component.html',
	styleUrls: ['./blog-more-stories.component.scss']
})
export class BlogMoreStoriesComponent {

	@Input()
	public url: string = '/blogs/';

	@Input()
	public blogRecommendedList: ContentPreview[] = [];
}
